// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"720d5ff1ea1ae5dabd91","114":"e0d7a853ceb1ea6c10ee","115":"9c8fb8d8f162132bd28e","162":"db7d3403168f5c70626b"}[chunkId] + ".chunk.js";
};